import { useMutation } from "relay-hooks";
import { useCallback } from "react";
import { addReportedIssueQL } from "../queries/reportIssue/addReportedIssueMutation";
import { addReportedIssueMutation } from "../queries/reportIssue/__generated__/addReportedIssueMutation.graphql";
import { isDevelopmentMode } from "tools/device";

type ReportIssueParams = {
  sCardId: string;
  sBackId: string | null;
  langBack: string | null;
  reasons: string[];
};

function useReportIssue() {
  const [doReportIssue] = useMutation<addReportedIssueMutation>(addReportedIssueQL);

  const reportIssue = useCallback(
    (params: ReportIssueParams) => {
      doReportIssue({
        variables: {
          ...params
        }
      });
      if (isDevelopmentMode()) {
        console.info("Report Issue", params);
      }
    },
    [doReportIssue]
  );

  return reportIssue;
}

export default useReportIssue;
